/**
 * Copyright 2024 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

export type VehicleType = 'car' | 'motorcycle' | 'recreation';

export const FITMENT_ICONS = {
  motorcycle: {
    FITS: '/images/fitment/moto-fits.svg',
    NEEDS_MORE_INFO: '/images/fitment/moto-needs-info.svg',
    DOES_NOT_FIT: '/images/fitment/moto-does-not-fit.svg',
  },
  recreation: {
    FITS: '/images/fitment/recreation-fits.svg',
    NEEDS_MORE_INFO: '/images/fitment/recreation-needs-info.svg',
    DOES_NOT_FIT: '/images/fitment/recreation-does-not-fit.svg',
  },
} as const;

export const CAR_FITMENT_STATUS_ICONS = {
  vehicle: '/images/vehicle-new.svg',
  FITS: '/images/icon-fitment-success-check.svg',
  DOES_NOT_FIT: '/images/icon-fitment-warning-red.svg',
  NEEDS_BASE_VEHICLE: '/images/icon-fitment-warning-orange.svg',
  NEEDS_MORE_INFO: '/images/icon-fitment-more-info-needed.svg',
} as const;

// Legacy exports for backward compatibility
export const vehicleIcon = {
  src: '/images/vehicle-new.svg',
  alt: 'vehicle icon',
};

export const needsMoreInfoIcon = {
  src: '/images/icon-fitment-more-info-needed.svg',
  alt: 'Needs more vehicle info',
};

export const successIcon = {
  src: '/images/icon-fitment-success-check.svg',
  alt: 'Fits your vehicle',
};

export const errorIcon = {
  src: '/images/icon-fitment-warning-red.svg',
  alt: 'Does not fit your vehicle',
};
